import Head from "next/head";
import { isLoggedIn } from "@utils/user/userCheck";
import { getCommunity } from "@queries/community.queries";
import { useContext, useEffect } from "react";
import { Store } from "@store";
import { appBaseUrl } from "@utils/BASE-URL";
import CommunityProfileComponent from "@components/community/CommunityProfile";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";

export default function CommunityProfile({ data, userData, lang }) {
  const { t } = useTranslation();
  const router = useRouter();

  let communityDetail_description = "";

  if (data?.headline) {
    communityDetail_description = data?.headline;
  } else if (data?.CommunityDetail) {
    communityDetail_description = data?.CommunityDetail?.description;
  } else {
    communityDetail_description =
      data?.name +
      `'s ${t("community-on-utsav-visit-the-page-to-get-regular-updates")}`;
  }

  const temp =
    // data.CommunityMetric.memberNo +
    // ` ${t('members-on-utsav')} | ` +
    communityDetail_description;

  const description = temp?.slice(0, 160)??"";
  const { dispatch } = useContext(Store);

  useEffect(() => {
    dispatch({ type: "SET_DATA", payload: { userData, lang } });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Head>
        <title>
          {data?.name || `${t("community-or-utsav-app-temple-and-festivals")}`}
        </title>
        <meta property="al:android:package" content="com.applex.utsav" />
        <meta property="fb:app_id" content="463332665401900" />
        <meta
          property="al:android:app_name"
          content={t("utsav-my-temple-and-festivals")}
        />
        <meta
          property="al:android:url"
          content={`${appBaseUrl}/community/${data.urlExtension}`}
        />
        <meta
          name="application-url"
          content={`${appBaseUrl}/community/${data.urlExtension}`}
        />

        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta property="og:title" content={data?.name + ` ${t("on-utsav")} `} />
        <meta
          property="og:url"
          content={`${appBaseUrl}/community/${data.urlExtension}`}
        />
        <meta
          property="og:image"
          content={
            data?.dp ||
            "https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj"
          }
          alt={
            data?.name
              ? data?.name + `${t("community-image")}`
              : `${t("utsav-community-image")}`
          }
        />
        <meta
          property="og:image:alt"
          content={
            data?.name
              ? data?.name + `${t("community-image")}`
              : `${t("utsav-community-image")}`
          }
        />

        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content={
            data?.name ||
            `${t("community-or-utsav-hindu-temple-online-puja-and-prasad")}`
          }
        />
        <meta
          name="twitter:description"
          content={
            description
              ? description
              : `${t(
                  "join-divine-communities-of-faith-and-spirituality-and-stay-updated-on-the-festivals-of-india"
                )}`
          }
        />
        <meta
          property="twitter:image"
          content={
            data?.dp ||
            "https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj"
          }
          alt={
            data?.name
              ? data?.name + "community image"
              : `${t("utsav-community-image")}`
          }
        />
        <meta name="twitter:site" content="@utsav_app" />

        <meta
          name="keywords"
          content={t(
            "utsav-utsavapp-view-mandir-dharmik-or-devotional-communities-on-utsav-app-online-puja-booking-online-puja-online-darshan-hindi-devotional-puja-app-darshan-app-online-puja-app-free-online-puja-hinduism-sanatan-dharma-lord-shiva-lord-krishna-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief"
          )}
        />

        <meta property="og:type" content={t("article")} />

        <link rel="icon" href="/favicon.ico" />
        <link
          rel="canonical"
          href={`${appBaseUrl}/${router.locale}/community/${data.urlExtension}`}
        />
        <link
          rel="alternate"
          href={`${appBaseUrl}/${router.locale}/community/${data.urlExtension}`}
          hrefLang={router.locale}
        />
        <link
          rel="alternate"
          href={`${appBaseUrl}/community/${data.urlExtension}`}
          hrefLang="x-default"
        />
      </Head>

      <CommunityProfileComponent data={data} />
    </>
  );
}

export async function getServerSideProps(context) {
  try {
    const { params, req, res } = context;
    const urlExtension = params?.params[0];

    const result = await isLoggedIn(req.headers.cookie, res);
    const userData = result.data;
    const lang = result.lang;
    const { data, err } = await getCommunity({
      communityID: urlExtension,
      accessToken: userData.accessToken,
    });

    if (err || !data) {
      return {
        redirect: {
          destination: "/home",
          permanent: false,
        },
      };
    }

    return {
      props: {
        data: data,
        userData: userData,
        lang: lang,
      },
    };
  } catch (err) {
    // console.error(err);

    return {
      redirect: {
        destination: "/home",
        permanent: false,
      },
    };
  }
}
